import { useCallback, useState } from 'react';

export enum LoadingState {
  Initial = 'initial',
  Loading = 'loading',
  Loaded = 'loaded',
  Error = 'error',
}

export const useLoading = (initialLoadingState?: LoadingState) => {
  const [loadingState, setIsLoading] = useState(
    initialLoadingState || LoadingState.Initial,
  );

  const updateLoadingState = useCallback((loadingState: LoadingState) => {
    setIsLoading(loadingState);
  }, []);

  const setLoadingState = useCallback(
    (loadingState: keyof typeof LoadingState) => {
      setIsLoading(LoadingState[loadingState]);
    },
    [],
  );

  return {
    loadingState,
    updateLoadingState,
    setLoadingState,
    isLoading: loadingState === LoadingState.Loading,
    isLoaded: loadingState === LoadingState.Loaded,
    isLoadError: loadingState === LoadingState.Error,
  };
};
